module.exports = __webpack_public_path__ + "static/img/4.ca8dd38.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/2/sp/4.png
// module id = tENk
// module chunks = 0